import { trackEvent } from "@utils/analytics/event-analytics";
import { WEB_ENGAGE } from "@utils/constants";
import { useCustomRouter as useRouter } from "@utils/events/customRouter";
import { getButtonDetails } from "@utils/events/eventState";
import { Store } from "@utils/store/ContextStore";
import dynamic from "next/dynamic";
import { useContext, useState } from "react";
import style from "../../styles/pujaDetails.module.css";
import EventTimer from "./EventTimer";
import { Typography } from "@mui/material";
const EventRegistrationList = dynamic(() => import("./EventRegistrationList"), {
  ssr: false
});
export default function PujaRegisterButton({
  data,
  clicked_from,
  handleToRegister,
  visibleBookBtn
}) {
  const router = useRouter();
  const {
    state: userContext
  } = useContext(Store);
  const viewerRole = data.viewerRole;
  const [viewRegistration, setViewRegistration] = useState(false);
  const {
    id,
    eventid
  } = router.query;
  const goToRegister = () => {
    // console.log("In goToRegister");
    // if (
    //   (data.eventTypeID === EVENT_TYPE.DONATION_CAMPAIGN ||
    //     data.eventTypeID === EVENT_TYPE.PUJA) &&
    //   data.CommunityEventRegistrationStatus &&
    //   data.communityEventRegistrationStatus?.statusCode !==
    //     KRIYA_STATUS.DELIVERED
    // ) {
    //   setOpenConfirmModal(true);
    //   return () => {};
    // }

    // console.log("In goToRegister");
    //navigateToRegister();
    handleToRegister();
  };
  const btnObj = getButtonDetails({
    data: {
      ...data,
      viewerRole
    },
    userContext,
    functions: {
      goToRegister,
      openRegistrationModal: () => setViewRegistration(true)
    },
    lang: router.locale
  });
  if (btnObj.hidden) return null;
  if (btnObj.type === 7) {
    return <button className={style.bookButton}>
        <EventTimer startTime={data.start} />
      </button>;
  }
  return visibleBookBtn ? <>
      <button className={style.bookButton} onClick={e => {
      e.preventDefault();
      //handleToRegister();
      // navigateToRegister();
      // window.location.replace("/#Puja_list");
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.KRIYA_BOOK + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
        [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.KRIYA_BOOK,
        [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(data.eventRegistrationAmount),
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: id,
        [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid
      });
      if (btnObj.onClickHandler) btnObj.onClickHandler();
    }}>
        <Typography fontFamily={"Poppins"} fontSize={"20px"} color={"#ffffff"} fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="PujaRegisterButton.jsx">
          {btnObj.text}
        </Typography>
      </button>

      {viewRegistration && data.EventRegistrations.length > 0 && <EventRegistrationList eventID={data.eventID} open={viewRegistration} setOpen={setViewRegistration} />}
    </> : <></>;
}